<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                    بروزرسانی اپلیکیشن
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>

            <div class="card card-style mb-3">
                <div class="content">
                    <div v-if="isKarnegasht==false" class="d-flex justify-content-center">
                        <a v-if="isFreeVersion==false" href='https://taskinoapp.com/' class="text-center mt-4" target="_blank">
                            <img class="rounded-circle" src="/assets/images/taskinoIcon-02.png" alt="taskinologo" width="128" height="128" />
                        </a>
                        <a v-else class="text-center mt-4">
                            <img class="rounded-circle" src="/assets/images/taskinoIcon-02.png" alt="taskinologo" width="128" height="128" />
                        </a>
                    </div>
                    <div v-if="isKarnegasht==true" class="d-flex justify-content-center">
                        <a v-if="isFreeVersion==false" href='https://karnegasht.com/' class="text-center mt-4" target="_blank">
                            <img class="rounded-circle" src="/assets/images/karnegasht-logo-02.png" alt="karnegashtlogo" width="128" height="128" />
                        </a>
                        <a v-else class="text-center mt-4">
                            <img class="rounded-circle" src="/assets/images/karnegasht-logo-02.png" alt="karnegashtlogo" width="128" height="128" />
                        </a>
                    </div>

                    <div v-if="info!=null">
                        <div class="content mt-1">
                            <h3 class="font-700 line-height-xl text-center mt-0">{{info.title}}</h3>
                            <div class="row mb-0">
                                <div class="col-4 px-0"><p class="color-theme font-500 py-1 text-left">تاریخ بروزرسانی:</p></div>
                                <div class="col-8 pl-0"><p class="font-700 py-1">{{ info.updateDateFa}}</p></div>

                                <div class="col-4 px-0"><p class="color-theme font-500 py-1 text-left">ورژن فعلی:</p></div>
                                <div class="col-8 pl-0"><p class="font-700 py-1">{{appVersionCode}}</p></div>

                                <div class="col-4 px-0"><p class="color-theme font-500 py-1 text-left">ورژن جدید:</p></div>
                                <div class="col-8 pl-0"><p class="font-700 py-1">{{info.versionCode}}</p></div>

                                <div class="col-4 px-0"><p class="color-theme font-500 py-1 text-left">نوع بروزرسانی</p></div>
                                <div class="col-8 pl-0">
                                    <p class="font-700 py-1">
                                        <span v-if="info.forceUpdate">اجباری</span>
                                        <span v-if="!info.forceUpdate">پیشنهادی</span>
                                    </p>
                                </div>
                                <div class="col-4 px-0"><p class="color-theme font-500 py-1 text-left">توضیحات:</p></div>
                                <div class="col-8 pl-0"><p class="font-700 py-1">{{ info.description}}</p></div>
                            </div>
                        </div>
                        <button @click="downloadLastUpdate(info.downloadUrl)" class="btn btn-full bg-highlight btn-m text-uppercase font-900 rounded-s shadow-xl w-100">دانلود بروزرسانی</button>
                    </div>
                </div>
            </div>
            <div class="card card-style">
                <p class="boxed-text-l mt-4 mb-2 font-700">
                    تهران، تهرانپارس غربی، خیابان فرجام شرقی، پلاک 76، واحد 10
                </p>
                <div v-if="isKarnegasht==false" class="d-flex justify-content-center">
                    <a v-if="isFreeVersion==false" target="_blank" :href="aboutUrl" class="text-center mt-2 font-weight-bold">
                        taskinoapp.com
                    </a>
                    <a v-else class="text-center mt-2 font-weight-bold">
                        taskinoapp.com
                    </a>
                </div>
                <div v-if="isKarnegasht==true" class="d-flex justify-content-center">
                    <a v-if="isFreeVersion==false" target="_blank" :href="aboutUrl" class="text-center mt-2 font-weight-bold">
                        karnegasht.com
                    </a>
                    <a v-else class="text-center mt-2 font-weight-bold">
                        karnegasht.com
                    </a>
                </div>


                <div v-if="isKarnegasht==false">
                    <p class="font-12 mt-3 text-center" v-if="isMinVersion==true && isFreeVersion==false">
                        جهت استفاده از نسخه دسکتاپ به نشانی اینترنتی زیر مراجعه نمایید
                        <span class="ltr d-inline-block">https://taskinoapp.com/</span>
                    </p>
                </div>
                <div v-if="isKarnegasht==true">
                    <p class="font-12 mt-3 text-center" v-if="isMinVersion==true && isFreeVersion==false">
                        جهت استفاده از نسخه دسکتاپ به نشانی اینترنتی زیر مراجعه نمایید
                        <sppn class="ltr d-inline-block">https://karnegasht.com/</sppn>
                    </p>
                </div>


            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                aboutUrl: "",
                info: null
            }
        },
        methods: {
            GetAboutLinkUrl() {
                this.$http.get("Task/GetAboutLinkUrl")
                    .then(data => {
                        this.aboutUrl = data.data;
                    });
            },
            GetMobileAppUpdate() {
                this.$http.get("Account/GetMobileAppUpdate?appVersionCode=" + this.appVersionCode)
                    .then(data => {
                        if (data.data.versionCode == undefined || data.data.versionCode == null || data.data.versionCode == "") {
                            this.showErrorMessage("در حال حاضر نسخه ای جهت بروزرسانی در دسترس نمی باشد!");
                            this.info = null;
                        } else {
                            this.info = data.data;
                        }

                    });
            },
            downloadLastUpdate(url) {
                window.open(url, "_blank")
            }
        },
        created() {
            this.GetMobileAppUpdate();
            this.GetAboutLinkUrl();
        }
    }
</script>